import {
  InputBase,
  Select as MuiSelect,
  SelectProps as MuiSelectProps,
  styled,
} from "@mui/material";

import { BORDER_COLORS } from "../../constants";
import { forwardRef } from "react";

const BootstrapInput = styled(InputBase)(({ size, slotProps }) => ({
  "& .MuiInputBase-input": {
    border: `1px solid ${BORDER_COLORS.default}`,
    borderRadius: "4px",
    padding: "0px 22px 0px 8px !important",
    width: "100%",
    fontSize: "12px",
    fontWeight: 500,
    color: "#000",
    height: size === "large" ? "38px" : size === "small" ? "24px" : "32px",
    lineHeight: size === "large" ? "38px" : size === "small" ? "24px" : "32px",
    ...slotProps?.input?.sx,
  },
  "& .MuiSelect-icon": {
    right: 0,
  },

  // "label + &": {
  //   marginTop: theme.spacing(3),
  // },
  // "& .MuiInputBase-input": {
  //   borderRadius: 4,
  //   position: "relative",
  //   backgroundColor: (theme.vars ?? theme).palette.background.paper,
  //   border: "1px solid #ced4da",
  //   fontSize: 16,
  //   padding: "10px 26px 10px 12px",
  //   transition: theme.transitions.create(["border-color", "box-shadow"]),
  //   "&:focus": {
  //     borderRadius: 4,
  //     borderColor: "#80bdff",
  //     boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
  //   },
  // },
}));

export const Select = forwardRef<any, MuiSelectProps>(
  ({ children, size, ...props }, ref) => {
    return (
      <MuiSelect ref={ref} {...props} input={<BootstrapInput size={size} />}>
        {children}
      </MuiSelect>
    );
  },
);

export default Select;
